<template>
  <div
    class="
      candidate-log
      d-flex flex-column justify-end
      fill-height
    "
  >
    <div
      ref="messagesContainer"
      class="messages-container pa-2 pa-md-5 pt-md-2 flex-grow-1"
      :class="{'huntica-nice-scroll': $vuetify.breakpoint.smAndUp}"
    >
      <VAlert v-if="!logs.length" type="info">
        {{ $t('empty') }}
      </VAlert>
      <CandidateLogMessages
        v-else
        :candidate="candidate"
        :messages="logs"
        :vacancy="vacancy"
        :online-interview="candidate.interview"
        :show-review="showReview"
        :pdf-resume-loading="pdfResumeLoading"
        @show-interview="$emit('show-interview', $event)"
        @show-online-interview="$emit('show-online-interview')"
        @change-active-tab="$emit('change-active-tab', $event)"
        @generate-candidate-pdf="$emit('generate-candidate-pdf')"
      />
    </div>
    <template v-if="!readonly">
      <VDialog
        v-if="$vuetify.breakpoint.smAndDown"
        v-model="mobileCommentDialog"
        fullscreen
        hide-overlay
      >
        <template v-slot:activator="{ on }">
          <VBtn
            text
            tile
            elevation="5"
            height="38"
            v-on="on"
          >
            <VIcon
              small
              color="blue"
              class="mr-2"
            >
              mdi-comment-outline
            </VIcon>
            <span class="text-decoration-underline blue--text">
              {{ $t('leaveComment') }}
            </span>
          </VBtn>
        </template>
        <VCard
          tile
          class="fill-height light-background pa-2"
        >
          <VBtn
            text
            tile
            color="grey"
            class="px-0"
            elevation="0"
            @click="mobileCommentDialog = false"
          >
            <VIcon
              small
              class="mr-2"
            >
              mdi-arrow-left
            </VIcon>
            <span>
              {{ $t('goBack') }}
            </span>
          </VBtn>
          <h3 class="headline pb-4">
            {{ $t('leaveComment') }}
          </h3>
          <CandidateLogCreateForm
            :candidate="candidate"
            :interview-type="interviewType"
            :office-interview-player-time="officeInterviewPlayerTime"
            :online-interview-question-index="activeQuestion"
            @log-entry-created="mobileCommentDialog = false"
            class="candidate-log-create-form"
          />
        </VCard>
      </VDialog>
      <CandidateLogCreateForm
        v-else
        :candidate="candidate"
        :interview-type="interviewType"
        class="candidate-log-create-form elevation-5 pa-3"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import compareDatesAsc from 'date-fns/compareAsc';
import CandidateLogMessages from './CandidateLogMessages.vue';
import CandidateLogCreateForm from '../../forms/CandidateLogCreateForm.vue';
import { safeGet } from '../../functions';

export default {
  name: 'CandidateLog',
  components: { CandidateLogCreateForm, CandidateLogMessages },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    vacancy: {
      type: Object,
      required: true,
    },
    onlineInterview: {
      type: Object,
      required: true,
    },
    showReview: {
      type: Boolean,
      required: true,
    },
    pdfResumeLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mobileCommentDialog: false,
    };
  },
  computed: {
    ...mapGetters('candidatePage', {
      interviewType: 'activeInterviewType',
      officeInterviewPlayerTime: 'officeInterviewPlayerTime',
      activeQuestion: 'activeQuestion',
    }),
    logs() {
      return [
        ...this.candidate.logs,
        ...safeGet(this.candidate, ['officeInterview', 'logs'], []),
        ...safeGet(this.candidate, ['interview', 'logs'], []),
      ].sort((a, b) => compareDatesAsc(new Date(a.createdAt), new Date(b.createdAt)));
    },
  },
  watch: {
    logs() {
      this.$nextTick(this.scrollToBottom);
    },
  },
  methods: {
    scrollToBottom() {
      if (this.$refs.messagesContainer) {
        const el = this.$refs.messagesContainer;
        el.scrollTop = el.scrollHeight;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .messages-container {
    width: 100%;
    @media #{map-get($display-breakpoints, 'md-and-up')} {
      height: 0px;
    }
  }
</style>

<i18n locale="en" lang="yaml">
  empty: Empty
  leaveComment: Leave a comment
  goBack: Go back
</i18n>

<i18n locale="ru" lang="yaml">
  empty: Пусто
  leaveComment: Оставить комментарий
  goBack: Назад
</i18n>
